import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-gif.mjs";
import { render } from "lit-html";
import { wait, TROVE, getRandomNumber, B } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

import Stock from "./Trove.json";
const stock: { category: string; folder: string; count: number }[] = Stock;

// TODO: begin with random jewel in category of the current holiday season!!! default: thank you
const HOLIDAY = 16; // 0 = thank you

export class HbGif extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;

    private jewel: HTMLElement;
    private form: HTMLFormElement;
    private copy: HTMLButtonElement;
    private shareBtn: HTMLButtonElement;

    private stock: HTMLElement;
    private stockBtn: HTMLButtonElement;
    private search: HTMLInputElement;
    private searchCategory: HTMLElement;
    private searchCategories: HTMLUListElement;
    private searchBtn: HTMLButtonElement;
    private stockImage: HTMLImageElement;

    private menu: HTMLElement;
    private page: HTMLElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;

    private ai: HTMLElement;
    private aiBtn: HTMLButtonElement;
    private prompt: HTMLInputElement;
    private promptBtn: HTMLButtonElement;
    private aiImage: HTMLImageElement;

    private message: HTMLTextAreaElement;
    private magic: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    private stockCategory = stock[HOLIDAY].folder;
    private stockItem = getRandomNumber(1, stock[HOLIDAY].count);
    private stockCount = stock[HOLIDAY].count;

    private aiItem = 0;
    private aiCount = 0;

    constructor() {
        super();
        render(template(null), this);

        this.jewel = this.querySelector("#hb-gif")!;
        this.form = this.querySelector("#hb-gif-form")!;
        this.copy = this.querySelector("#hb-gif-copy")!;
        this.shareBtn = this.querySelector("button[type=submit]")!;

        this.stock = this.querySelector("#hb-gif-stock")!;
        this.stockBtn = this.querySelector("#hb-gif-menu-stock")!;
        this.search = this.querySelector("#hb-gif-stock-search")!;
        this.searchCategory = this.querySelector("#hb-gif-stock-categories")!;
        this.searchCategories = this.searchCategory
            .firstElementChild as HTMLUListElement;
        this.searchBtn = this.querySelector("#hb-gif-stock-magic")!;
        this.stockImage = this.querySelector("#hb-gif-stock-image")!;

        this.menu = this.querySelector("#hb-gif-menu")!;
        this.page = this.querySelector("#hb-gif-menu-page")!;
        this.previous = this.querySelector("#hb-gif-menu-previous")!;
        this.next = this.querySelector("#hb-gif-menu-next")!;

        this.ai = this.querySelector("#hb-gif-ai")!;
        this.aiBtn = this.querySelector("#hb-gif-menu-ai")!;
        this.prompt = this.querySelector("#hb-gif-ai-prompt")!;
        this.promptBtn = this.querySelector("#hb-gif-ai-magic")!;
        this.aiImage = this.querySelector("#hb-gif-ai-image")!;

        this.message = this.querySelector("#hb-gif-message")!;
        this.magic = this.querySelector("#hb-gif-message-magic")!;
        this.paste = this.querySelector("#hb-gif-message-paste")!;
        this.trash = this.querySelector("#hb-gif-message-trash")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-gif",
            override: true
        };

        this.modal = new Modal(this.jewel, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.renderStock();
        this.addStockListeners();
        this.addAIListeners();
        this.addMessageListeners();

        this.previous.addEventListener("click", () => {
            this.goToStock(false);
        });

        this.next.addEventListener("click", () => {
            this.goToStock(true);
        });

        this.form.addEventListener("submit", this.share.bind(this));
        this.copy.addEventListener("click", async (event) => {
            // const message = this.message.value.trim()
            //     ? this.message.value.trim() + "\n\n"
            //     : "";
            const message = "";
            await navigator.clipboard.writeText(message + this.getUrl()); // cannot do link first bc werid bug
            alert("This B-Word has been copied to your clipboard!");
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
        });
    }

    private getUrl() {
        return `${B}/f/${this.stockCategory}-${this.stockItem}`;
    }

    private addStockListeners() {
        this.stockBtn.addEventListener("click", () => {
            this.aiBtn.classList.remove("underline", "uppercase");
            this.stockBtn.classList.add("underline", "uppercase");
            this.menu.classList.remove("hidden");
            this.menu.classList.add("inline-flex");
            this.stock.classList.remove("hidden");
            this.ai.classList.add("hidden");
            //this.search.focus();
        });

        this.search.addEventListener("focus", () => {
            this.renderCategories(this.search.value);
            this.searchCategory.classList.remove("hidden");
        });

        this.search.addEventListener("blur", async () => {
            await wait(0.1); // needed for click select
            this.searchCategory.classList.add("hidden");
        });

        this.search.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.renderCategory();
            }
        });

        this.search.addEventListener("keyup", (event: KeyboardEvent) => {
            this.renderCategories(this.search.value);
        });

        this.searchBtn.addEventListener(
            "click",
            this.renderCategory.bind(this)
        );

        // useless bc gif is not supported; only png
        this.stockImage.addEventListener("click", async () => {
            if (this.heartbank.isAdmin()) {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = `${TROVE}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.jpg`;

                await new Promise<void>((resolve, reject) => {
                    img.onload = () => resolve();
                    img.onerror = reject;
                });

                const canvas = document.createElement("canvas");
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;

                const ctx = canvas.getContext("2d");
                if (!ctx) throw new Error("Canvas not supported");

                ctx.drawImage(img, 0, 0);

                const blob = await new Promise<Blob>((resolve) =>
                    canvas.toBlob((b) => resolve(b!), "image/png")
                );

                await navigator.clipboard.write([
                    new ClipboardItem({ "image/png": blob })
                ]);

                alert("This B-Word has been copied to your clipboard!");
            }
        });
    }

    private addAIListeners() {
        this.aiBtn.addEventListener("click", () => {
            this.aiBtn.classList.add("underline", "uppercase");
            this.stockBtn.classList.remove("underline", "uppercase");
            this.menu.classList.add("hidden");
            this.menu.classList.remove("inline-flex");
            this.stock.classList.add("hidden");
            this.ai.classList.remove("hidden");
            //this.prompt.focus();
        });
    }

    private addMessageListeners() {
        this.magic.addEventListener("click", () => {
            if (
                confirm("Would you like Miss Aquarius™ AI to improve your comment?")
            ) {
                this.message.value =
                    stock.find(
                        (category) => category.folder === this.stockCategory
                    )?.category || "";
                this.message.focus();
            }
            //alert("AI writing assistant coming soon...");
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.message.value.trim() === "" ||
                confirm(
                    "Would you like to replace your comment with the one you copied to your clipboard?"
                )
            ) {
                this.message.value = await navigator.clipboard.readText();
                this.message.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.message.value &&
                confirm("Would you like to clear your comment and start over?")
            ) {
                this.message.value = "";
                this.message.focus();
            }
        });
    }

    private renderCategory() {
        if (this.searchCategories.childElementCount > 0) {
            const item = this.searchCategories
                .firstElementChild as HTMLLIElement;
            this.stockCategory = item.dataset.category!;
            this.stockItem = 1;
            this.stockCount = parseInt(item.dataset.count!);
            this.renderStock();
            this.search.blur();
        }
    }

    private renderCategories(search: string) {
        this.searchCategories.innerHTML = "";
        for (const item of stock)
            if (
                search === "" ||
                item.category
                    .toLowerCase()
                    .includes(search.trim().toLowerCase())
            ) {
                const li = document.createElement("li");
                li.classList.add(
                    "block",
                    "px-4",
                    "py-2",
                    "hover:bg-gray-100",
                    "dark:hover:bg-gray-600",
                    "dark:hover:text-white"
                );
                li.dataset.category = item.folder;
                li.dataset.count = item.count.toString();
                li.textContent = item.category;
                li.onclick = () => {
                    this.stockCategory = item.folder;
                    this.stockItem = 1;
                    this.stockCount = item.count;
                    this.search.value = "";
                    this.search.placeholder = item.category;
                    this.renderStock();
                };
                this.searchCategories.appendChild(li);
            }

        if (this.searchCategories.childElementCount === 0) {
            const li = document.createElement("li");
            li.classList.add(
                "block",
                "px-4",
                "py-2",
                "text-gray-500",
                "dark:text-gray-400"
            );
            li.textContent = "No Categories Found";
            this.searchCategories.appendChild(li);
        }
    }

    // TODO: show spinner if await is too long
    async show(category: string, item: string) {
        if (category) this.stockCategory = category;
        if (item) this.stockItem = parseInt(item);
        await this.renderStock();
        this.stockBtn.click();
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async renderStock() {
        const item = this.page.firstElementChild as HTMLSpanElement;
        const total = this.page.lastElementChild as HTMLSpanElement;
        //console.log(this.stockCategory, this.stockItem, this.stockCount);

        item.textContent = this.stockItem.toString();
        total.textContent = this.stockCount.toString();

        this.stockImage.src = `${TROVE}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`;
    }

    private goToAI(direction: boolean) {}

    private async goToStock(direction: boolean) {
        if (direction) {
            if (this.stockItem < this.stockCount) {
                ++this.stockItem;
            } else {
                this.stockItem = 1;
            }
        } else {
            if (this.stockItem > 1) {
                --this.stockItem;
            } else {
                this.stockItem = this.stockCount;
            }
        }

        await this.renderStock();
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        let file: File | null = null;
        if (this.heartbank.isAdmin()) {
            const response = await fetch(
                `${TROVE}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`
            );
            const blob = await response.blob();
            file = new File([blob], "B-Word.gif", { type: "image/gif" });
        }

        const shareData = {
            title: "HeartBank® Gif",
            text: "", //this.message.value.trim(),
            url: this.getUrl(),
            files: file ? [file] : []
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
